/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x36f4=['oldRevisionId','changes','newRevisionId'];(function(_0x4899da,_0x36f432){const _0x474b1b=function(_0x23e1a9){while(--_0x23e1a9){_0x4899da['push'](_0x4899da['shift']());}};_0x474b1b(++_0x36f432);}(_0x36f4,0x195));const _0x474b=function(_0x4899da,_0x36f432){_0x4899da=_0x4899da-0x0;let _0x474b1b=_0x36f4[_0x4899da];return _0x474b1b;};import{Collection as _0x2c80d6}from'ckeditor5/src/utils';export default class f{constructor(_0x34e361,_0x156e66){this[_0x474b('0x2')]=_0x34e361,this[_0x474b('0x0')]=_0x156e66,this[_0x474b('0x1')]=new _0x2c80d6();}['_setData'](_0x43528d){for(const _0x26707b of _0x43528d['changes'])this['changes']['add'](_0x26707b);}}